import * as React from 'react';
import { observer } from 'mobx-react';

import { useLocalStore } from 'shared/entities/common/hooks';
import { useRootStore, useUserStore } from 'stores/index';
import {
  ManagerSegmentStore,
  ManagerSegmentStoreProvider
} from 'stores/managerSegmentStore';

import ManagerSegmentModalContent from './ManagerSegmentModalContent';

const ManagerSegmentModal: React.FC = () => {
  const rootStore = useRootStore();
  const userStore = useUserStore();
  const storeCtx = useLocalStore<ManagerSegmentStore>(
    () => new ManagerSegmentStore(rootStore)
  );
  const { store } = storeCtx;
  const managerId = userStore.user?.id;
  const showSegment = userStore.showSegment;

  React.useEffect(() => {
    if (showSegment === null || !managerId) {
      store.reset();
      return;
    }

    store.sync(managerId, showSegment);
  }, [managerId, showSegment]);

  return (
    <ManagerSegmentStoreProvider value={storeCtx}>
      <ManagerSegmentModalContent />
    </ManagerSegmentStoreProvider>
  );
};

export default observer(ManagerSegmentModal);
